import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import { RouterLink } from '@angular/router';

export type MNavTriggerVariant = 'default' | 'ai-compact';

@Component({
  selector: 'm-nav-trigger',
  templateUrl: './m-nav-trigger.component.html',
  styleUrls: ['./m-nav-trigger.component.scss'],
  imports: [NgTemplateOutlet, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MNavTriggerComponent {
  readonly active = input(false);
  readonly open = input(false);
  readonly disabled = input(false);
  readonly ariaLabel = input<string>();
  readonly ariaCurrent = input<string>();
  readonly ariaPressed = input<boolean>();
  readonly ariaHaspopup = input(false);
  readonly ariaExpanded = input<boolean>();
  readonly routerLink = input<string | unknown[]>();
  readonly queryParams = input<Record<string, unknown>>();
  readonly variant = input<MNavTriggerVariant>('default');

  readonly clicked = output<Event>();

  onClick(event: Event): void {
    if (this.disabled()) {
      return;
    }
    this.clicked.emit(event);
  }
}
